import React from 'react';
import EntryYoumo from './entry-youmo';
import EntryUmo from './entry-umo';

const EntryLanguage = (props) => {
  if (props.SiteTheme === 'youmo') return <EntryYoumo {...props} />;
  if (props.SiteTheme === 'umo') return <EntryUmo {...props} />;
};

export default EntryLanguage;
